{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "8e9949e5af6a57d259f65593bb2812a2b92292b5",
  "LastCommitMessage": "Merge branch test into dev-update-version19",
  "LastCommitAuthor": "francesco.moroni",
  "LastCommitTime": "Wed Nov 4 08:49:08 2026 +0100",
  "VersionNumber": "21973"
}